const React = require('react');

import PropTypes from 'prop-types'

import {
  Pagination as BsPagination,
  Pager
} from 'react-bootstrap'

export default class Pagination extends React.Component {
  constructor(props) {
    super(props)
    this.handleNextPage = this.handleNextPage.bind(this)
    this.handlePrevPage = this.handlePrevPage.bind(this)
  }

  handleNextPage(){
    this.props.onNextPage()
  }

  handlePrevPage(){
    this.props.onPrevPage()
  }

  render() {
    const pagination = this.props.pagination
    const currentPage = pagination.offset == 0
    ? 1
    : (pagination.offset/pagination.limit)+1

    const start = pagination.offset == 0
    ? 1
    : pagination.offset+1;

    const end = currentPage * pagination.limit > this.props.count
    ? this.props.count
    : currentPage*pagination.limit

    const isLast = this.props.count == 0 || this.props.count <= (currentPage * pagination.limit)
    return (
      <div>
        <BsPagination>
          <BsPagination.First
            disabled={pagination.offset==0}
            onClick={pagination.offset==0 ? undefined : this.props.onFirstPage}
          />
          <BsPagination.Prev
            disabled={pagination.offset==0}
            onClick={pagination.offset==0 ? undefined : this.handlePrevPage}
          />
          <BsPagination.Item>Showing {start} to {end} of {this.props.count} {this.props.noun}(s)</BsPagination.Item>
          <BsPagination.Next
            disabled={isLast}
            onClick={isLast ? undefined : this.handleNextPage}
          />
          <BsPagination.Last
            disabled={isLast}
            onClick={isLast ? undefined : this.props.onLastPage}
          />
        </BsPagination>
      </div>
    )
  }
}

Pagination.defaultProps = {
  noun: 'sites'
}

Pagination.propTypes = {
  noun: PropTypes.string
}